// Enumerations
import { AppStateContextType } from 'contexts/types/app.contexts.type';
import { AppErrorEnumeration } from 'enumerations/app-error.enumeration';
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';

const getLayoutScreenDetailsErrorByState = (
  currentState: AppStateContextType
): AppErrorEnumeration =>
  ({
    [AppStatesEnumeration.CHECKOUT_PENDING]: AppErrorEnumeration.GET_ID_VALIDATION_DETAILS_FAILED,
    [AppStatesEnumeration.CHECKOUT_INCOME]: AppErrorEnumeration.GET_INCOME_DETAILS_FAILED,
    [AppStatesEnumeration.CHECKOUT_DOWNPAYMENT]: AppErrorEnumeration.GET_PAYMENT_DETAILS_FAILED,
    [AppStatesEnumeration.CHECKOUT_IDENTIFICATION]:
      AppErrorEnumeration.GET_IDENTIFICATION_DETAILS_FAILED,
    [AppStatesEnumeration.CHECKOUT_SIGNING]: AppErrorEnumeration.GET_SIGNATURE_DETAILS_FAILED,
  }[currentState] || AppErrorEnumeration.UNKNOWN_ERROR);

export { getLayoutScreenDetailsErrorByState };
